import React from 'react';
import {
  Card, Typography, Box, CardContent,
} from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import ErrorIcon from '@material-ui/icons/Error';
import SvgIcon from '@material-ui/core/SvgIcon';

import { ReactComponent as ScanIcon } from '../../assets/icons/scan.svg';

interface RepairCardProps {
  barcode: string,
  error?: boolean,
  iconType?: 'repair' | 'barcode',
  primaryText?: string,
  secondaryText?: string
}

const RepairCard: React.FC<RepairCardProps> = ({
  barcode = 'Missing Number', error, iconType = 'barcode', primaryText = 'Current Repair', secondaryText = 'Barcode Number',
}) => (
  <Card style={{ height: '100%' }}>
    <Box p={2}>
      <Box pl={2}>
        { (iconType === 'repair')
          ? <BuildIcon />
          : <SvgIcon fontSize="large" component={ScanIcon} />}
        <Typography variant="h6">
          {primaryText}
        </Typography>
      </Box>
      <CardContent>
        <Typography variant="h4">
          {`${barcode} `}
          {error && <ErrorIcon style={{ color: 'red', marginTop: '0.20em' }} />}
        </Typography>
        <Typography color="textSecondary">
          {secondaryText}
        </Typography>
      </CardContent>
    </Box>
  </Card>
);

export default RepairCard;
